import { apiGet } from "@softmax/observatory-client/client";
import {
  ApiError,
  DEFAULT_BACKEND_FETCH_TIMEOUT_MS,
} from "@softmax/observatory-client/transport";
import { withRequestDeadline } from "@softmax/observatory-client/request-signal";
import type { LeaguePublic, Schemas } from "@softmax/observatory-client/types";

import { getActualViewer } from "@/data/viewer";

import { publicRead } from "@/data/api";

export async function resolveSelectedWatchLeague({
  signal,
  path,
}: {
  signal?: AbortSignal | undefined;
  path: string | null;
}): Promise<{
  selected: LeaguePublic | null;
  viewer: Schemas["WhoAmIResponse"] | null;
}> {
  if (!path) return { selected: null, viewer: null };

  const publicSelection = await publicRead<LeaguePublic>({
    path,
    signal,
  }).catch((error: unknown) => {
    if (error instanceof ApiError && [401, 403, 404].includes(error.status))
      return null;

    throw error;
  });

  if (publicSelection) return { selected: publicSelection, viewer: null };

  const viewer = await getActualViewer({ signal });

  if (!viewer) return { selected: null, viewer: null };

  const selected = await apiGet<LeaguePublic>(path, {
    elevatedPrivileges: false,
    signal: withRequestDeadline(signal, DEFAULT_BACKEND_FETCH_TIMEOUT_MS),
  }).catch((error: unknown) => {
    if (error instanceof ApiError && [403, 404].includes(error.status))
      return null;

    throw error;
  });

  if (!selected) return { selected: null, viewer: null };

  return { selected, viewer };
}
